import React from "react";
import DynamoDBTool from "../../../components/calculators/DynamoDb";
import Layout from "../../../components/layout";
import { CardBox } from "../../../components/cardbox";

const DynamodbDesigner = () => {
  return (
    <Layout>
      <CardBox>
        <DynamoDBTool />
      </CardBox>
    </Layout>
  );
};

export default DynamodbDesigner;
